/**
 * OPFS (Origin Private File System) — sandboxed, persistent, fast.
 * Falls back to nothing on engines without OPFS (re-decrypt on next load).
 */
import type { Summary } from './types.ts';

const FILE = 'dial-summary.json';

async function opfs(): Promise<FileSystemDirectoryHandle | null> {
  if (!('storage' in navigator) || !navigator.storage.getDirectory) return null;
  try {
    return await navigator.storage.getDirectory();
  } catch {
    return null;
  }
}

export async function saveSummary(summary: Summary): Promise<void> {
  const dir = await opfs();
  if (!dir) return;
  const handle = await dir.getFileHandle(FILE, { create: true });
  const writable = await handle.createWritable();
  await writable.write(JSON.stringify(summary));
  await writable.close();
}

export async function loadSummary(): Promise<Summary | null> {
  const dir = await opfs();
  if (!dir) return null;
  try {
    const handle = await dir.getFileHandle(FILE);
    const file = await handle.getFile();
    const text = await file.text();
    return JSON.parse(text) as Summary;
  } catch {
    return null;
  }
}

export async function clearSummary(): Promise<void> {
  const dir = await opfs();
  if (!dir) return;
  try {
    await dir.removeEntry(FILE);
  } catch {
    // ignore
  }
}
